import React, { useEffect, useState } from 'react';
import SectionHeader from '../components/ui/sectionHeader/SectionHeader';
import greenTickIcon from '../components/ui/planbutton/img/greentickIcon.png';
import chatUs from '../assets/images/chatUs.svg';
import call from '../assets/images/call.svg';
import './paymentSuccessfulStyle.scss';
import CustomModal from '../components/modal/CustomModal';
import { getPolicyDoc } from '../components/JsonToSoapXml/getPolicyDoc';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getTransDtls } from '../components/JsonToSoapXml/getTransDtls';
import LoadingMask from '../components/loadingMask/LoadingMask';
import QuoteToPolicyConvert from '../components/JsonToSoapXml/QuoteToPolicyConvert';
import { getTransDtlsSoap } from '../components/SoapXmlToJson/getTransDtlsSoap';
import { Placeholder } from "react-bootstrap";
import ConfirmBox from '../components/modal/ConfirmBox';
import redXIcon from '../components/ui/planbutton/img/redXIcon.png'
import { getValidAccessToken } from '../services/oauthservice.js'
import { createApiLog } from '../helpers/apiLogger.js';
import { updateJourneyLog } from '../helpers/journeyLogger.js';
import { encryptRSA } from '../services/encrypt.js';
export default function PaymentSuccessful() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [policyNo, SetPolicyNo] = useState('');
  const [transDtls, SetTransDtls] = useState();
  const [documents, setDocuments] = useState([]);
  const [pgSuccessData, setPgSuccessData] = useState();
  const [pgFailedData, setPgFailedData] = useState();
  const { loading } = useSelector(state => state.loadingReducer);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errMessage, setErrMessage] = useState('')
  const [quoteData, setQuoteData] = useState(null);

  const { partnerConfig } = useSelector((state) => state.partnerConfig || {});
  const { SRC_BUS_ID = 'CP', PARTNER_ID } = partnerConfig || {};

  const cleanLabel = (label) => label.replace(/ - \d+$/, "");

  const priorityOrder = [
    "Policy Schedule",
    "Premium Debit Note",
    "Premium Note",
    "Receipt",
    "Quote Schedule",
    "Proposal Form",
    "Braxtone Receipt",
    "Critical Illness",
    "Precision Voucher"
  ];

  // Create a label map for precise matching
  const labelMap = {
    "Policy Schedule": "Policy Schedule",
    "Premium Debit Note": "Premium Debit Note",
    "Premium Note": "Premium Note",
    "Receipt": "Receipt",
    "Quote Schedule": "Quote Schedule",
    "Proposal Form": "Proposal Form",
    "Braxtone Receipt": "Braxtone Receipt",
    "Critical Illness Document": "Critical Illness",
    "Precision Voucher": "Precision Voucher"
  };

  const sortDocuments = (docs) => {
    const seen = new Set();

    const normalize = (label) => {
      const cleaned = label.replace(/ - \d+$/, "").trim();
      return labelMap[cleaned] || cleaned;
    };

    const uniqueDocs = docs.filter((doc) => {
      const normLabel = normalize(doc.label);
      if (seen.has(normLabel)) return false;
      seen.add(normLabel);
      return true;
    });

    return uniqueDocs.sort((a, b) => {
      const aPriority = priorityOrder.indexOf(normalize(a.label));
      const bPriority = priorityOrder.indexOf(normalize(b.label));
      return aPriority - bPriority;
    });
  };

  const handleHome = () => {
    navigate('/');
  };


  useEffect(() => {
    const fetchPaymentResponse = async () => {
    const br = new URLSearchParams(window.location.search).get('br');
    if (!br) return;

    try {
      const token = await getValidAccessToken();

      const response = await fetch(
        `${process.env.REACT_APP_DIC_ADMIN_API}/v1/payments/payment-responses?br=${encodeURIComponent(br)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );

      const result = await response.json();
      const data = result.data;



      const quoteNo = data.mer_param_2;

      // 2. Call backend with quoteNo
      const quoteRes = await fetch(
        `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/byQuoteNo?quoteNo=${encodeURIComponent(quoteNo)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
        }
      );


      const quoteJson = await quoteRes.json();

      // 3. Save single object to state
      setQuoteData(quoteJson.data[0] || {}); // ✅ default to {} instead of []

      if (data.order_status === "Successful" || data.order_status === "Shipped") {
        setPgSuccessData(data);

        await updateJourneyLog({
          TRANS_ID: quoteJson?.data[0]?.TRANS_ID,
          JOURNEY_STATUS: "PAYMENT_SUCCEEDED",
          REMARKS: ''
        })

      } else {
        setPgFailedData(data);

        await updateJourneyLog({
          TRANS_ID: quoteJson?.data[0]?.TRANS_ID,
          JOURNEY_STATUS: "PAYMENT_FAILED",
          REMARKS: 'Payment transaction failed'
        })
      }

    } catch (err) {
      console.error("PG Response fetch error:", err);
    }
    };

    fetchPaymentResponse();
  }, []);

  useEffect(() => {
    const fetchDocuments = async () => {
      const soapRequest = getPolicyDoc({ policyNo, srcBusId: SRC_BUS_ID });
      try {
        dispatch({ type: 'LOADING', payload: true });

        const response = await fetch(`${process.env.REACT_APP_GET_POLICY_DOC}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'text/xml',
            },
            body: soapRequest,
          }
        );

        const textResponse = await response.text();
        
        await createApiLog({
          PARTNER_ID: PARTNER_ID,
          APP_ID: 1,
          COB: "MOTOR",
          TRANS_ID: quoteData?.TRANS_ID,
          API: process.env.REACT_APP_GET_TRANS_DTLS,
          REQUEST: soapRequest,
          REQUEST_STATUS: "Success",
          RESPONSE: textResponse,
        })

        await updateJourneyLog({
          TRANS_ID: quoteData?.TRANS_ID,
          JOURNEY_STATUS: "POLICY_ISSUED",
          REMARKS: 'Policy Converted Successful'
        })

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(textResponse, 'text/xml');

        const documentListNodes = xmlDoc.getElementsByTagName('documentList');
        const docs = Array.from(documentListNodes).map((node) => {
          const [label, url] = node.textContent.split('~~');
          return { label, url };
        });

        const sortedDocs = sortDocuments(docs);
        setDocuments(sortedDocs);
      } catch (err) {
        console.error('Error fetching documents:', err);
        dispatch({ type: "LOADING", payload: false });

        await createApiLog({
          PARTNER_ID: PARTNER_ID,
          APP_ID: 1,
          COB: "MOTOR",
          TRANS_ID: quoteData?.TRANS_ID,
          API: process.env.REACT_APP_GET_TRANS_DTLS,
          REQUEST: soapRequest,
          REQUEST_STATUS: "Error",
          RESPONSE: err,
        })
      } finally {
        dispatch({ type: 'LOADING', payload: false });
      }
    };

    if (policyNo && quoteData?.TRANS_ID) {
      fetchDocuments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policyNo, quoteData, dispatch]);

  const updateMotorquotes = async (policyNo, status) => {
    const { mer_param_2 } = pgSuccessData
    const data = {
      quoteNo: mer_param_2,
      quoteStatus:policyNo? "Policy_ISSUED":"QUOTE_GENERATED",
      paymentStatus: status,
      policyNo: policyNo
    }
    try {
      const token = await getValidAccessToken()
      const encrypted = await encryptRSA(data)
      const response = await fetch(`${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ encrypted }),
      });
      const responseData = await response.json();

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: quoteData?.TRANS_ID,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
        REQUEST: data,
        REQUEST_STATUS: "Success",
        RESPONSE: responseData,
      })

      return responseData
    } catch (error) {
      console.error('Error posting data:', error);

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: quoteData?.TRANS_ID,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
        REQUEST: data,
        REQUEST_STATUS: "Failed",
        RESPONSE: error,
      })
    }
  }

  useEffect(() => {
    const fetchTransactionDetails = async () => {
      dispatch({ type: "LOADING", payload: true });
      try {
        const { mer_param_2 } = pgSuccessData;
        if (!mer_param_2) {
          console.warn("Missing quote number");
          return;
        }

        // First SOAP: quote to policy conversion
        const soapRequest = QuoteToPolicyConvert({ ...pgSuccessData, srcBusId: SRC_BUS_ID });
        try {
          const responseQuoteToPolicy = await fetch(`${process.env.REACT_APP_QUOTE_TO_POLICY}`, {
          method: "POST",
          headers: { "Content-Type": "text/xml" },
          body: soapRequest,
        });

          const responseText = await responseQuoteToPolicy.text()
          
          await createApiLog({
            PARTNER_ID: PARTNER_ID,
            APP_ID: 1,
            COB: "MOTOR",
            TRANS_ID: quoteData?.TRANS_ID,
            API: process.env.REACT_APP_GET_TRANS_DTLS,
            REQUEST: soapRequest,
            REQUEST_STATUS: "Success",
            RESPONSE: responseText,
          })

        } catch (err1) {
          await createApiLog({
            PARTNER_ID: PARTNER_ID,
            APP_ID: 1,
            COB: "MOTOR",
            TRANS_ID: quoteData?.TRANS_ID,
            API: process.env.REACT_APP_GET_TRANS_DTLS,
            REQUEST: soapRequest,
            REQUEST_STATUS: "Error",
            RESPONSE: err1,
          })
          console.error("Error in QuoteToPolicyConvert call:", err1);
        }

        // Second SOAP: get transaction details
        const searchQuoteRequest = getTransDtls({ quoteNo: mer_param_2, txnTyp: "P", srcBusId: SRC_BUS_ID });
        try {
        const searchQuoteResponse = await fetch(`${process.env.REACT_APP_GET_TRANS_DTLS}`, {
          method: "POST",
          headers: { "Content-Type": "text/xml" },
          body: searchQuoteRequest,
        });

        const responseText = await searchQuoteResponse.text();

        await createApiLog({
            PARTNER_ID: PARTNER_ID,
            APP_ID: 1,
            COB: "MOTOR",
            TRANS_ID: quoteData?.TRANS_ID,
            API: process.env.REACT_APP_GET_TRANS_DTLS,
            REQUEST: searchQuoteRequest,
            REQUEST_STATUS: "Success",
            RESPONSE: responseText,
          })

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(responseText, "text/xml");
        const transDtls = getTransDtlsSoap(xmlDoc);
        const policyNo = xmlDoc.getElementsByTagName("policyNo")[0]?.textContent || "";
          const resultUpdateQuote = await updateMotorquotes(policyNo, "PAYMENT_SUCCEEDED");

        SetTransDtls(transDtls);
        SetPolicyNo(policyNo);
        } catch (err2) {
          console.error("Error in getTransDtls call:", err2);

          await createApiLog({
            PARTNER_ID: PARTNER_ID,
            APP_ID: 1,
            COB: "MOTOR",
            TRANS_ID: quoteData?.TRANS_ID,
            API: process.env.REACT_APP_GET_TRANS_DTLS,
            REQUEST: searchQuoteRequest,
            REQUEST_STATUS: "Error",
            RESPONSE: err2,
          })
        }
      } catch (error) {
        console.error("Unexpected error fetching transaction details:", error);
      } finally {
        dispatch({ type: "LOADING", payload: false });
      }
    };

    if (pgSuccessData && quoteData?.TRANS_ID) {
    fetchTransactionDetails();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pgSuccessData, quoteData]);

  useEffect(() => {
    const fetchTransactionDetails = async () => {

      const { mer_param_2 } = pgFailedData;
        if (!mer_param_2) {
          console.warn("Missing quote number");
          return;
        }

      const searchQuoteRequest = getTransDtls({ quoteNo: mer_param_2, txnTyp: "Q" });
      try {
        dispatch({ type: "LOADING", payload: true });
      // Second SOAP: get transaction details
        const searchQuoteResponse = await fetch(`${process.env.REACT_APP_GET_TRANS_DTLS}`, {
          method: "POST",
          headers: { "Content-Type": "text/xml" },
          body: searchQuoteRequest,
        });

        const responseText = await searchQuoteResponse.text();

        await createApiLog({
          PARTNER_ID: PARTNER_ID,
          APP_ID: 1,
          COB: "MOTOR",
          TRANS_ID: quoteData?.TRANS_ID,
          API: process.env.REACT_APP_GET_TRANS_DTLS,
          REQUEST: searchQuoteRequest,
          REQUEST_STATUS: "Success",
          RESPONSE: responseText,
        })

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(responseText, "text/xml");
        const transDtls = getTransDtlsSoap(xmlDoc)
        const resultUpdateQuote = await updateMotorquotes('', 'PAYMENT_FAILED')

        SetTransDtls(transDtls)
      } catch (error) {
        console.error("Error fetching transaction details:", error);
        
        await createApiLog({
          PARTNER_ID: PARTNER_ID,
          APP_ID: 1,
          COB: "MOTOR",
          TRANS_ID: quoteData?.TRANS_ID,
          API: process.env.REACT_APP_GET_TRANS_DTLS,
          REQUEST: searchQuoteRequest,
          REQUEST_STATUS: "Success",
          RESPONSE: error,
        })
      } finally {
        dispatch({ type: "LOADING", payload: false });
      }
    };

    if (pgFailedData && quoteData?.TRANS_ID) {
      fetchTransactionDetails();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pgFailedData, quoteData]);

  const handlePdfClick = async (pdf) => {
    try {
      dispatch({ type: "LOADING", payload: true });
      const response = await fetch(pdf.url);
      const blob = await response.blob();

      // Create Object URL
      const fileUrl = URL.createObjectURL(blob);

      setSelectedPdf(fileUrl);
      setIsSummaryOpen(true);
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      console.error("Failed to load PDF:", error);
    }
  };  

  const handlePreviewPdf = async (fileurl) => {
    try {
      dispatch({ type: "LOADING", payload: true });

      const response = await fetch(fileurl);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("pdf")) {
        throw new Error("Invalid file type. Expected a PDF.");
      }

      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);

      setSelectedPdf(fileUrl);
      setIsSummaryOpen(true);

    } catch (error) {
      console.error("Failed to load PDF:", error);
      setShowModal(true)
      setErrMessage("Failed to load or preview PDF. Please check the file and try again.")
      dispatch({ type: "LOADING", payload: false });
    } finally {
      dispatch({ type: "LOADING", payload: false });
    }
  };

  const handleDownloadDoc = async (url, label) => {
    try {
      // Step 1: Check if URL is valid and downloadable
      const response = await fetch(url, { method: 'HEAD' });

      if (!response.ok || !response.headers.get('Content-Type')?.includes('pdf')) {
        throw new Error("File not found or not a PDF.");
      }

      // Step 2: Trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = `${cleanLabel(label)}.pdf`;
      document.body.appendChild(link); // required for Firefox
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      setShowModal(true)
      setErrMessage("Download failed. The file may be missing or not a valid PDF.")
      dispatch({ type: "LOADING", payload: false });
    }
  };

  const showPaymentSkeleton = !transDtls || !transDtls.insuredName;
  const showDocumentSkeleton = !documents || !documents.length > 0

  const handleCloseConfirm = () => {
    setErrMessage('')
    setShowModal(false)
  }

  return (
    <>
      {loading && <LoadingMask />}

      <ConfirmBox
        show={showModal}
        message={errMessage}
        onCancel={handleCloseConfirm} />

      {pgSuccessData && <div className='container'>
        {/* Section Header */}
        <div className='row mb-2'>
          <div className='col-md-12'>
            <SectionHeader title='Motor Insurance ' stepNo={3} totalStep={3} />
          </div>
        </div>
        <div className='container bg-white'>
          <div className='row mt-2 d-flex justify-content-center'>
            <div className="col-md-1 mt-3 d-flex ms-auto">
              <button className="btn btn-secondary btn-sm" onClick={handleHome} style={{ padding: "4px 10px" }}>
                Home
              </button>
            </div>
            <div className='col-md-12 mt-5 d-flex justify-content-center'>
              <img
                src={greenTickIcon}
                alt='greentickicon'
                className='img-fluid'
              />
            </div>
            <div className='col-md-12 mt-2 d-flex justify-content-center'>
              <label className='payment-success-label'>
                Your premium payment is successful.
              </label>
            </div>
            <div className='col-md-12 mt-2 d-flex justify-content-center'>
              <label className='thank-you-label'>Thank you!</label>
            </div>

              <div class="card shadow-sm rounded-4 p-4" style={{ maxWidth: "400px" }}>
                <h5 class="fw-semibold mb-4">Policy Details</h5>

                <div class="mb-2 d-flex justify-content-between">
                  <span class="text-muted">Policy No</span>
                  <span class="fw-medium">{transDtls?.policyNo}</span>
                </div>

                <div class="mb-2 d-flex justify-content-between">
                  <span class="text-muted">Insured Name</span>
                  <span class="fw-medium">{transDtls?.insuredName}</span>
                </div>

                <div class="mb-2 d-flex justify-content-between">
                  <span class="text-muted">Insurance Type</span>
                  <span className="fw-medium">
                    {transDtls?.productType}
                  </span>
                </div>

                <hr class="my-2" />

                <div class="d-flex justify-content-between fw-semibold mt-2">
                  <span>Total Premium</span>
                <span class="text-dark">{pgSuccessData?.currency} {pgSuccessData?.amount}</span>
              </div>
            </div>

            {/* <div className="row mt-2 justify-content-center">
              <div className="col-lg-8 col-md-12">
                <ul className="list-group">
                  {documents.map((doc, index) => (
                    <li key={index} className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-md-6 col-4">
                          <span>{cleanLabel(doc.label)}</span>
                        </div>
                        <div className="col-md-6 col-8 text-md-end">
                          <button
                            className="btn small-btn-primary btn-sm me-2"
                            onClick={() => handlePreviewPdf(doc.url)}
                          >
                            Preview
                          </button>
                          <button
                            className="btn small-btn-primary btn-sm"
                            onClick={() => handleDownloadDoc(doc.url, doc.label)}
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div> */}

            <div className='col-md-12 mt-5 d-flex justify-content-center'>
              <p className='acknowledge-para'>
                Your policy has been sent to you via WhatsApp and email,
                according to your <br />
                communication preferences. Additionally, an SMS link has been
                provided for you to
                <br /> download your policy document
              </p>
            </div>
            <div className='row mt-2 mb-5'>
              <div className='col-md-4'></div>

              <div className='col-md-4 need-help-section ps-4'>
                <div className='row'>
                  {/* Need Help Section */}
                  <div className='col-md-12 mt-2'>
                    <label className='need-help-label'>Need Help?</label>
                  </div>

                  {/* Chat with Us */}
                  <div className='col-md-5 mb-3'>
                    <div className='d-flex align-items-center mt-3'>
                      <img src={chatUs} alt='chat' />
                      <div className='d-flex flex-column ms-2  lh-sm'>
                        <label className='chat-us-label mb-0'>
                          CHAT WITH US
                        </label>
                        <span className='grey-label mt-0'>Click here</span>
                      </div>
                    </div>
                  </div>

                  {/* Call us on our helpline */}
                  <div className='col-md-7 mb-3'>
                    <div className='d-flex align-items-center mt-3'>
                      <img src={call} alt='chat' />
                      <div className='d-flex flex-column ms-2  lh-sm'>
                        <label className='chat-us-label mb-0'>
                          CALL US ON OUR HELPLINE
                        </label>
                        <span className='grey-label mt-0'>8000 77 77</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-4'></div>
            </div>
          </div>
        </div>
      </div>}

      {pgFailedData && <div className="container">
        {/* Section Header */}
        <div className="row mb-2">
          <div className="col-md-12">
            <SectionHeader title="Motor Insurance " stepNo={3} totalStep={3} failedStep={3} />
          </div>
        </div>

        <div className="container bg-white">
          <div className="row mt-2 d-flex justify-content-center">
            <div className="col-md-1 mt-3 d-flex ms-auto">
              <button className="btn btn-secondary btn-sm" onClick={handleHome} style={{ padding: "4px 10px" }}>
                Home
              </button>
            </div>
            <div className="col-md-12 mt-5 d-flex justify-content-center">
              <img src={redXIcon} alt="redtickicon" className="img-fluid" />
            </div>
            <div className="col-md-12 mt-2 d-flex justify-content-center">
              <label className='payment-success-label'>Sorry. Payment transaction failed!</label>
            </div>
            <div className="col-md-12 mt-2 d-flex justify-content-center">
              <label className='thank-you-label'>Please try again later.</label>
            </div>
            <div className="col-md-12 mt-3 mb-1"></div>
            {/* <div className="col-md-12 mt-5 mb-5"></div>  */}

            <div class="card shadow-sm rounded-4 p-4" style={{ maxWidth: "400px" }}>
              <h5 class="fw-semibold mb-4">Quote Details</h5>

              <div class="mb-2 d-flex justify-content-between">
                <span class="text-muted">Quote No</span>
                <span class="fw-medium">{pgFailedData?.mer_param_2}</span>
              </div>

              <div class="mb-2 d-flex justify-content-between">
                <span class="text-muted">Insured Name</span>
                <span class="fw-medium">{transDtls?.insuredName}</span>
              </div>

              <div class="mb-2 d-flex justify-content-between">
                <span class="text-muted">Insurance Type</span>
                <span className="fw-medium">
                  {transDtls?.productType}
                </span>
              </div>
            </div>
            <div className="col-md-12 mt-3 mb-1"></div>
            <div className="row mt-2 mb-5">
              <div className="col-md-4"></div>

              <div className="col-md-4 need-help-section ps-4">
                <div className="row">

                  {/* Need Help Section */}
                  <div className="col-md-12 mt-2">
                    <label className="need-help-label">Need Help?</label>
                  </div>

                  {/* Chat with Us */}
                  <div className="col-md-5 mb-3">
                    <div className="d-flex align-items-center mt-3">
                      <img src={chatUs} alt="chat" />
                      <div className="d-flex flex-column ms-2  lh-sm">
                        <label className="chat-us-label mb-0">CHAT WITH US</label>
                        <span className="grey-label mt-0">Click here</span>
                      </div>
                    </div>
                  </div>

                  {/* Call us on our helpline */}
                  <div className="col-md-7 mb-3">
                    <div className="d-flex align-items-center mt-3">
                      <img src={call} alt="chat" />
                      <div className="d-flex flex-column ms-2  lh-sm">
                        <label className="chat-us-label mb-0">CALL US ON OUR HELPLINE</label>
                        <span className="grey-label mt-0">8000 77 77</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-md-4"></div>
            </div>

          </div>
        </div>
      </div>}

      <CustomModal
        isOpen={isSummaryOpen}
        onClose={() => setIsSummaryOpen(false)}
        title='Preview Document'

      >
        <div className="modal-body" style={{ overflow: 'hidden', padding: 0, height: '70vh' }}>
          {selectedPdf && (
            <iframe
              title='View Document'
              src={`${selectedPdf}#page=1&toolbar=0`}
              width="100%"
              height="95%"
              style={{ border: 'none' }}
            ></iframe>
          )}
        </div>

      </CustomModal>
      {/* <div
        className="modal fade"
        id="pdfPreviewModal"
        tabIndex="-1"
        aria-labelledby="pdfPreviewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="pdfPreviewModalLabel">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              
            </div>
          </div>
        </div>
      </div> */}

    </>
  );
}
